import React from 'react';
import { AWSImage } from '../../../../types';
import { getExemplarImageURL } from '../../../../utils';
import { StyledImageBlockRow } from '../../../Styled/StyledButtons';
import { StyledModalEditImageHeader, StyledModalEditImageReplaceButton } from '../../../Styled/StyledEditImage';
import { AccordionWrapper } from '../../../Styled/StyledWrappers';
import { SquareImage } from '../SquareImage';

interface IReplaceImageModal {
  defaultImages: Array<AWSImage>;
  relatedImages: Array<AWSImage>;
  selectedImageUUID: string;
  isButtonDisabled: boolean;
  buttonText: string;
  color: string;
  handleReplaceButtonClick: (imageUUID: string) => void;
  onImageSelect: (event: React.MouseEvent<HTMLImageElement>, imageId: string) => void;
}

export const ReplaceImageModalContent = (props: IReplaceImageModal): JSX.Element => {
  const {
    defaultImages,
    relatedImages,
    selectedImageUUID,
    isButtonDisabled,
    buttonText,
    color,
    handleReplaceButtonClick,
    onImageSelect,
  } = props;

  const renderImages = (data: Array<AWSImage>, rowSize: number) => {
    const rows = [];
    for (let i = 0, j = data.length; i < j; i += rowSize) {
      const chunk = data.slice(i, i + rowSize);
      const row = (
        <StyledImageBlockRow key={`image-row-${i}`}>
          {chunk.map(({ uuid }) => (
            <SquareImage
              src={getExemplarImageURL(uuid, relatedImages)}
              color={color}
              isSelected={selectedImageUUID === uuid}
              onClick={event => {
                onImageSelect(event, uuid);
              }}
              key={`image-${uuid}`}
            />
          ))}
        </StyledImageBlockRow>
      );
      rows.push(row);
    }
    return rows;
  };

  return (
    <div>
      <StyledModalEditImageHeader>Select an Image</StyledModalEditImageHeader>
      <AccordionWrapper>{renderImages(defaultImages, 5)}</AccordionWrapper>
      <StyledModalEditImageReplaceButton
        tabIndex={0}
        data-testid="modal-replace-image-btn"
        aria-label={`${buttonText} image`}
        disabled={isButtonDisabled}
        color={color}
        onClick={() => {
          handleReplaceButtonClick(selectedImageUUID);
        }}
      >
        {buttonText}
      </StyledModalEditImageReplaceButton>
    </div>
  );
};
